import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import './i18n'; // Initialize i18n
import HomePage from './pages/HomePage';
import ViewPage from './pages/ViewPage';
import UploadPage from './pages/UploadPage';
import GiftUploadPage from './pages/GiftUploadPage';
import ResetPage from './pages/ResetPage';
import AdminDashboard from './pages/AdminDashboard';
import AnalyticsPage from './pages/AnalyticsPage';
import AnalyticsHub from './pages/AnalyticsHub';
import TagHistory from './pages/TagHistory';
import WhiteLabelSetup from './pages/WhiteLabelSetup';
import MasterAdminDashboard from './pages/MasterAdminDashboard';
import ContentEditorPage from './pages/ContentEditorPage';
import CampaignDetailPage from './pages/CampaignDetailPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AboutPage from './pages/AboutPage';
import FAQPage from './pages/FAQPage';
import GiftsPricingPage from './pages/GiftsPricingPage';
import NotFoundPage from './pages/NotFoundPage';
import InvestorDeck from './pages/InvestorDeck';
import AdvancedAnalytics from './pages/AdvancedAnalytics';
import PasswordGate from './components/PasswordGate';
import InvestorGate from './components/InvestorGate';
import CookieConsent from './components/CookieConsent';
import './App.css';

// Protected wrapper for admin routes
const ProtectedRoute = ({ children }) => (
  <PasswordGate>{children}</PasswordGate>
);

// Investor preview wrapper for marketing pages
const InvestorRoute = ({ children }) => (
  <InvestorGate>{children}</InvestorGate>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Marketing pages - Investor protected */}
          <Route path="/" element={<InvestorRoute><HomePage /></InvestorRoute>} />
          <Route path="/home" element={<InvestorRoute><HomePage /></InvestorRoute>} />
          <Route path="/about" element={<InvestorRoute><AboutPage /></InvestorRoute>} />
          <Route path="/faq" element={<InvestorRoute><FAQPage /></InvestorRoute>} />
          <Route path="/gifts" element={<InvestorRoute><GiftsPricingPage /></InvestorRoute>} />
          <Route path="/gifts/pricing" element={<InvestorRoute><GiftsPricingPage /></InvestorRoute>} />
          <Route path="/privacy" element={<InvestorRoute><PrivacyPage /></InvestorRoute>} />
          <Route path="/terms" element={<InvestorRoute><TermsPage /></InvestorRoute>} />
          
          {/* Investor Deck - Own password protection */}
          <Route path="/investor" element={<InvestorDeck />} />
          <Route path="/deck" element={<InvestorDeck />} />
          
          {/* Admin routes - Password protected */}
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/analytics" element={<ProtectedRoute><AnalyticsHub /></ProtectedRoute>} />
          <Route path="/admin/analytics/advanced" element={<ProtectedRoute><AdvancedAnalytics /></ProtectedRoute>} />
          <Route path="/admin/analytics/advanced/:nfcCode" element={<ProtectedRoute><AdvancedAnalytics /></ProtectedRoute>} />
          <Route path="/admin/analytics/:nfcCode" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
          <Route path="/admin/history/:nfcCode" element={<ProtectedRoute><TagHistory /></ProtectedRoute>} />
          <Route path="/admin/campaigns/:campaignId" element={<ProtectedRoute><CampaignDetailPage /></ProtectedRoute>} />
          <Route path="/admin/whitelabel" element={<ProtectedRoute><WhiteLabelSetup /></ProtectedRoute>} />
          <Route path="/admin/master" element={<ProtectedRoute><MasterAdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/content" element={<ProtectedRoute><ContentEditorPage /></ProtectedRoute>} />
          
          {/* App pages - Public (for NFC/QR functionality) */}
          <Route path="/create/:nfcCode" element={<GiftUploadPage />} />
          <Route path="/gift/:nfcCode" element={<GiftUploadPage />} />
          <Route path="/view/:nfcCode" element={<ViewPage />} />
          <Route path="/upload/:nfcCode" element={<UploadPage />} />
          <Route path="/:nfcCode" element={<ViewPage />} />
          <Route path="/:nfcCode/tag" element={<UploadPage />} />
          <Route path="/:nfcCode/reset" element={<ProtectedRoute><ResetPage /></ProtectedRoute>} />
          
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      <CookieConsent />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;